import { AdHocCustomPopupProcessor } from "./adhoc-custom-popup-processor";


export class AdHocSpParamCustomPopupController {
    static $inject = ["$scope", "$location", "$window"];

    private customPopupProcessor: AdHocCustomPopupProcessor;

    public paramKey: string;

    public modalOpen: boolean = true;
    public mode: string = "";
    public allowMultiple: boolean = true;  // Assuming we can always filter on multiple values for now - currently no way to indicate single or multiple
    public paramOutput: string | number | string[] = "";
    public paramDisplay: string = "";
    public shouldSave: boolean = false;
    public wasCanceled: boolean = false;
    public hasHierarchy: boolean = false;
    public showAdvancedMode: boolean = false;

    constructor(
        $scope: ng.IScope,
        $location: ng.ILocationService,
        $window: ng.IWindowService) {

        this.customPopupProcessor = new AdHocCustomPopupProcessor($window);

        // If the data is in tree format, set the allow multiple value to false
        $scope.$watch(() => this.hasHierarchy, (newValue, oldValue) => {
            if (newValue) {
                this.allowMultiple = false;
            }
        });

        return;
    }

    public init() {

        var columnName: string = this.customPopupProcessor.getColumnName();
        var columnNameParsed: string = this.parseColumnName(columnName);

        this.paramKey = columnNameParsed;
        this.paramOutput = this.customPopupProcessor.getExistingValue(columnName);

        return;
    }

    private parseColumnName(columnName: string): string {

        var parseToken: string = '].[PARAM_';
        var index: number = columnName.lastIndexOf(parseToken);

        if (index < 0)
            return null;

        var ret: string = columnName.substring(
            index + parseToken.length,
            columnName.length - 1
        );

        return ret;
    }
}

